export default "__VITE_ASSET__a00df132__"